export const OPTHINES = {
  voteName: '2020project/2020chongqing_beautiful_one',
  number: {
    mustRank: true,
  },
  themeColor: {
    activeBgColor: 'rgb(19, 86, 128)',
    inactiveBgColor: 'rgb(187, 211, 220)',
  },
  tabs: [
    {
      tabName: '相关新闻',
      tabPath: '/20200710HWGR/News',
    },
    {
      tabName: '活动介绍',
      tabPath: '/20200710HWGR/Rules',
    },
  ],
};
